import { useEffect, useState } from 'react';

import { useAppDispatch } from '@src/core/hooks';
import { loadTerms } from '@src/stores/app';

export enum TermsDocumentTypeEnum {
  TERMS_OF_USE = 'terms_of_use',
  PRIVACY_POLICY = 'privacy_policy',
}

export const useTermsAcceptance = () => {
  const dispatch = useAppDispatch();
  const [openTerms, setOpenTerms] = useState<TermsDocumentTypeEnum | null>(null);

  useEffect(() => {
    dispatch(loadTerms());
  }, [dispatch]);

  const openTermsOfUse = () => setOpenTerms(TermsDocumentTypeEnum.TERMS_OF_USE);
  const openPrivacyPolicy = () => setOpenTerms(TermsDocumentTypeEnum.PRIVACY_POLICY);
  const closeTerms = () => setOpenTerms(null);

  return { openTerms, openTermsOfUse, openPrivacyPolicy, closeTerms };
};
